import { searchParamsBuilder } from '@/shared/utils/search-params-builder';

export const urlBuilder = (pathname: string, params: Record<string, string> = {}) => {
    const context      = document.body.dataset.contextPath || '';
    const searchString = searchParamsBuilder(params);

    return `${ context }/${ pathname }${ searchString ? '?' + searchString : '' }`;
};
